import { AppBar } from "@features/dashboard/layouts/AppBar";
import { useAppStore } from "@hooks/useAppStore";
import EmptyState from "@memorang/ui/components/EmptyView";
import { Stack } from "expo-router";
import { Linking } from "react-native";
import AccessDeniedImage from "../../../assets/undraw_access_denied.svg";

const UnauthorizedRoute = () => {
	const appConfig = useAppStore((state) => state.app);
	const unauthorizedConfig = appConfig.auth?.unauthorized;

	const title = unauthorizedConfig?.title ?? "Unable to authenticate";
	const subtitle =
		unauthorizedConfig?.subtitle ??
		"We are sorry, but we are unable to authenticate you. Go to login to continue.";
	const shouldShowCta = Boolean(
		unauthorizedConfig?.ctaLabel &&
			unauthorizedConfig?.ctaHref &&
			/^https?:\/\//.test(unauthorizedConfig.ctaHref),
	);
	const ctaLabel = shouldShowCta ? unauthorizedConfig?.ctaLabel : undefined;
	const ctaHref = shouldShowCta ? unauthorizedConfig?.ctaHref : undefined;

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: true,
					header: () => <AppBar title="" variant="public" showLogo />,
				}}
			/>
			<EmptyState
				title={title}
				subtitle={subtitle}
				image={AccessDeniedImage}
				cta={ctaLabel}
				handleAction={ctaHref ? () => Linking.openURL(ctaHref) : undefined}
			/>
		</>
	);
};

export default UnauthorizedRoute;
